export const PROMOTION_GIFT_META = {
  coupon: {
    heroTitle: "쿠폰 선물이 도착했어요!",
    badgeText: "할인쿠폰",
    defaultValidity: "유효 기간 내 사용 가능",
  },
  voucher: {
    heroTitle: "쿠폰 선물이 도착했어요!",
    badgeText: "무료쿠폰",
    defaultValidity: "유효 기간 내 사용 가능",
  },
  precoupon: {
    heroTitle: "예약권 선물이 도착했어요!",
    badgeText: "예약권",
    defaultValidity: "유효 기간 내 사용 가능",
  },
  "gift-ticket": {
    heroTitle: "티켓 선물이 도착했어요!",
    badgeText: "티켓",
    defaultValidity: "유효 기간 내 사용 가능",
  },
  "gift-voucher": {
    heroTitle: "쿠폰 선물이 도착했어요!",
    badgeText: "무료쿠폰",
    defaultValidity: "유효 기간 내 사용 가능",
  },
  "gift-coupon": {
    heroTitle: "쿠폰 선물이 도착했어요!",
    badgeText: "할인쿠폰",
    defaultValidity: "유효 기간 내 사용 가능",
  },
  "gift-reservation": {
    heroTitle: "예약권 선물이 도착했어요!",
    badgeText: "예약권",
    defaultValidity: "유효 기간 내 사용 가능",
  },
};

export function normalizeSiteLines(lines) {
  if (!Array.isArray(lines)) {
    return [];
  }

  return lines
    .map((line) => (typeof line === "string" ? line.trim() : ""))
    .filter(Boolean);
}

function toRemainingCount(value) {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

export function getPromotionGiftMeta(type) {
  return PROMOTION_GIFT_META[type] || PROMOTION_GIFT_META.coupon;
}

export function mapCouponGiftItem(item) {
  return {
    type: "coupon",
    itemName: item?.coupon_name || "",
    imageUrl: item?.image || "",
    senderName: item?.display_business_name || item?.username || "",
    remainingCount: toRemainingCount(item?.remainings),
    siteLines: normalizeSiteLines(item?.site_names),
    validityText: PROMOTION_GIFT_META.coupon.defaultValidity,
    noticeHtml: item?.descript || "",
  };
}

export function mapVoucherGiftItem(item) {
  return {
    type: "voucher",
    itemName: item?.voucher_name || "",
    imageUrl: item?.image || "",
    senderName: item?.display_business_name || item?.business_name || item?.username || "",
    remainingCount: toRemainingCount(item?.remainings),
    siteLines: normalizeSiteLines(item?.site_name ? [item.site_name] : []),
    validityText: PROMOTION_GIFT_META.voucher.defaultValidity,
    noticeHtml: item?.precautions || "",
  };
}

export function getPrecouponPackageLines(availablePackages) {
  if (!Array.isArray(availablePackages)) {
    return [];
  }

  return availablePackages
    .map((packInfo) => {
      if (!Array.isArray(packInfo)) {
        return "";
      }

      const packageName = packInfo[1] || "";
      const siteName = packInfo[2] || "";

      if (siteName && packageName) {
        return `${siteName} - ${packageName}`;
      }

      return packageName || siteName || "";
    })
    .filter(Boolean);
}

export function mapPrecouponGiftItem(item) {
  const availablePackages = getPrecouponPackageLines(item?.available_packages);

  const validityText =
    item?.start_date && item?.end_date
      ? `${item.start_date} ~ ${item.end_date} 사용 가능`
      : PROMOTION_GIFT_META.precoupon.defaultValidity;

  return {
    type: "precoupon",
    itemName: item?.precoupon_name || "",
    imageUrl: item?.image || "",
    senderName: item?.display_business_name || item?.business_name || item?.username || "",
    remainingCount: toRemainingCount(item?.remainings),
    siteLines: normalizeSiteLines(availablePackages),
    validityText,
    noticeHtml: item?.description || "",
  };
}
